import { PageButtonSchema } from '@/views/sports/components/PageButton/styles/PageButton.styles';

export const pageButtonStyles: PageButtonSchema = {
  button: {
    variant: 'unstyled',
    fontSize: '2xs',
    textShadow: 'none',
    color: 'gamma.200',
    h: 'fit-content',
    textTransform: 'uppercase',
    sx: {
      '&&': {
        fontWeight: 'bold',
      },
      svg: {
        bg: 'gamma.500',
        p: '0.5',
        color: 'blackAlpha.500',
        borderRadius: 'sm',
      },
    },
    _hover: {
      color: 'gamma.500',
    },
  },
};
